import axios from 'axios';
// import router from '../router/router';
import {formatDate,randomNumber } from '../utils/utils';
import Container from '../utils/container';
import Router from '../router/router';
import SiteEnv from '../utils/siteEnv';
import Auth from '../utils/auth';
import { Toast } from 'mint-ui';

const catchNetError = axiosPromise => new Promise((resolve, reject) => {
    axiosPromise.then(response => resolve(response))
    .catch(error => {
        //error.message = Network Error 没有处理好
        if (error.response && error.response.status === 401) {
            Auth.clearToken();
            let refer = location.pathname + location.search;
            Router.push({name:'login',params:{'action':'begin'},query:{refer:refer}});
        }
        //reject(error);
        reject();
    });
});

export default class Fetch {
    constructor(path, tab) {
        this.path = path;
        this.axios = axios;
        this.tab = tab;
        this.axios.interceptors.request.use(
            config => {
                SiteEnv.fillClientId(config.headers);
                Auth.fillLocalToken(config.headers);
                console.log(config.url);
                return config;
            }, error => {
            	console.log('错误消息：'+JSON.stringify(error))
                return Promise.reject(error);
            }
        );
        this.axios.interceptors.response.use(
            response => {
                Auth.handResponseToken(response.headers);
                return response;
            },
            error => {
            	if(error.response != undefined){
            		Toast(error.response.data.msg);

            		console.log("接口请求报错了，错误信息如下")
            		console.log("接口地址："+error.response.config.url+""+error.response.config.data)
            		console.log("请求头："+error.response.headers['content-type'])
            		console.log("商家id："+error.response.headers['x-curr-site'])
            		console.log("用户id："+error.response.headers['x-curr-user'])
            		console.log("状态码："+error.response.data.code)
            		console.log("时间："+error.response.data.date)
            		console.log("描述："+error.response.data.msg)
            		console.log("参数："+JSON.stringify(error.response.data.params))
            		console.log("reqId："+error.response.data.reqId)
            	}else{
                    console.error(error);
//          		Toast("未知错误");
            		Router.push({name:'network'});
            	}
                return Promise.reject(error);
            }
        );
    }

    // get 请求
    getRequest(subPath, param = '') {
        return catchNetError(
            this.axios.get(`${this.path}${subPath}?${param}`, {
                headers: {
                }
            })
        );
    }
    // del 请求
    delRequest(subPath, param = '') {
        return catchNetError(
            this.axios.delete(`${this.path}${subPath}?${param}`,{
                headers: {
                }
            })
        );
    }
    // post 请求
    postRequest(subPath, data, param = '') {
        return catchNetError(
            this.axios.post(`${this.path}${subPath}?${param}`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
        );
    }
    // put 请求
    putRequest(subPath, data, param = '') {
        return catchNetError(
            this.axios.put(`${this.path}${subPath}?${param}`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
        );
    }
    // form  'Content-Type': 'application/x-www-form-urlencoded'
    formRequest(subPath, data) {
        return catchNetError(
            this.axios.post(`${this.path}${subPath}`, data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/fetch/fetch.js